import styled from "styled-components";

export const Bar = styled.div`
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  min-width: 320px;
  background: #282828;
  padding: 8px 16px 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  z-index: 100;
  box-sizing: border-box;
`;

export const PriceCol = styled.div`
  flex: 1;
  min-width: 0;
  color: #fff;
`;

export const Amount = styled.div`
  font-size: 18px;
  font-weight: 900;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 28px;
`;

export const InfoBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
`;

export const Sub = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  line-height: normal;
`;

export const BuyBtn = styled.button`
  flex-shrink: 0;
  width: 148px;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background-image: linear-gradient(92.19deg, #53b2fe 0%, #065af3 100%);
  background-size: cover;
  color: #fff;
  font-weight: 900;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  line-height: 24px;
  text-align: center;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
`;

export const BottomSheet = styled.div`
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 20px 20px 0 0;
  z-index: 201;
  overflow: hidden;
`;

export const SheetTopBar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 16px 16px;
  border-bottom: 1px solid #d8d8d8;
  background: #fff;
`;

export const SheetCloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
`;

export const SheetTitle = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  line-height: normal;
`;

export const SheetContent = styled.div`
  padding: 0 16px 24px;
`;

export const PriceRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #e8e8e8;
`;

export const PriceRowLabel = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 900;
  color: #4a4a4a;
  min-width: 0;
`;

export const PriceRowValue = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 900;
  color: #4a4a4a;
  text-align: right;
  min-width: 0;
`;

export const TotalRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 12px 0 0;
`;

export const TotalLabel = styled.div`
  flex-shrink: 0;
`;

export const TotalLabelMain = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
`;

export const TotalLabelSub = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #757575;
  margin-top: 4px;
`;

export const TotalValue = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  text-align: right;
`;
